/**
 * mw-sticky-bar.js — Alpine component for the bottom sticky bar.
 *
 * Shows when .pdp__buy leaves the viewport (downward), hides when it
 * re-enters. CTA scrolls back to the buy box. Registered via
 * alpine:init so the data is wired before Alpine evaluates x-data.
 */
document.addEventListener('alpine:init', function () {
  if (!window.Alpine) return;
  window.Alpine.data('mwStickyBar', function () {
    return {
      visible: false,
      observer: null,
      target: null,

      init: function () {
        var self = this;
        var attach = function () {
          self.target = document.querySelector('.pdp__buy');
          if (!self.target) {
            window.setTimeout(attach, 500);
            return;
          }
          self.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              self.visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 100;
            });
          }, { root: null, threshold: 0, rootMargin: '-100px 0px 0px 0px' });
          self.observer.observe(self.target);
        };
        attach();
      },

      scrollToProduct: function () {
        var target = document.querySelector('#mw-product-title') ||
                     document.querySelector('.pdp__buy') ||
                     document.querySelector('.pdp');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
  });
});
